export const GET_SS_RUN_DATA='GET_SS_RUN_DATA';
export const GET_SS_RUN_DATA_ERROR='GET_SS_RUN_DATA_ERROR';
export const GET_SS_DATASET_DATA='GET_SS_DATASET_DATA';
export const GET_SS_DATASET_DATA_ERROR='GET_SS_DATASET_DATA_ERROR';


// WEBPACK FOOTER //
// ./src/redux/semanticSgm/actionTypes.js